import React, { FC, useEffect, useRef, useState } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { ChangeDeliveryDateModal } from '../components/change-delivery-date-modal/ChangeDeliveryDateModal';
import { MessageModal } from '../components/message-modal/MessageModal';
import { BackToSubscriptionTop } from '../components/pickup/BackToSubscriptionTop';
import { PickupProductListPickup } from '../components/pickup/PickupProductListPickup';
import { PickupShippingProductList } from '../components/pickup/PickupShippingProudctList';
import { Menu } from '../components/subscription-detail/Menu';
import { useSubscriptionAddProducts } from '../hooks/use-subscription-add-products';
import { useSubscriptionDetail } from '../hooks/use-subscription-detail';
import { useSubscriptionLine } from '../hooks/use-subscription-line';
import { useUpdateDeliveryDate } from '../hooks/use-update-delivery-date';
import { MessageContentViewType } from '../types/view/message-content-view-type';
import { ProductInfoViewType } from '../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../types/view/recommend-product-info-view-type';
import { SubscriptionStatus } from '../types/api/subscriptions-api-type';
import { useSubscriptionSummary } from '../hooks/use-subscription-summary';

export const Pickup: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptionContractId, setSubscriptionContractId] = useState('');
  const [subscriptionStatus, setSubscriptionStatus] = useState<SubscriptionStatus>('ACTIVE');

  const [registeredProducts, setRegisteredProducts] = useState<ProductInfoViewType[]>([]);
  useEffect(() => {
    console.log('registeredProducts changed!', registeredProducts);
  }, [registeredProducts]);
  const [pausedProducts, setPausedProducts] = useState<ProductInfoViewType[]>([]);
  useEffect(() => {
    console.log('pausedProducts changed!', pausedProducts);
  }, [pausedProducts]);
  const [recommendProducts, setRecommendProducts] = useState<RecommendProductInfoViewType[]>([]);
  useEffect(() => {
    console.log('recommendProducts changed!', recommendProducts);
  }, [recommendProducts]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    console.log('loading changed!', loading);
  }, [loading]);
  const [loadCompleted, setLoadCompleted] = useState(false);
  const [cartItems, setCartItems] = useState<{ variantId: string; quantity: number; sellingPlanId: string }[]>([]);

  const [changeDeliveryDateModalActive, setChangeDeliveryDateModalActive] = useState(false);

  const [messageModalActive, setMessageModalActive] = useState(false);
  const [messageContent, setMessageContent] = useState<MessageContentViewType>();

  const { subscription, setSubscription, getSubscriptionDetail, getRegisteredProducts } = useSubscriptionDetail(
    setting,
    setSubscriptionContractId,
    setRegisteredProducts,
    setPausedProducts,
    setRecommendProducts,
    setLoadCompleted,
    setSubscriptionStatus,
  );
  const { summary, subscriptionDetail } = useSubscriptionSummary(setting, subscription);

  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight, summary, pausedProducts, recommendProducts]);

  // スクロール量を親windowから受け取る
  const [scrollOffset, setScrollOffset] = useState(0);
  useEffect(() => {
    const parentScrollEvent = (event: MessageEvent) => {
      const { pageYOffset } = event.data;
      if (!pageYOffset) return;

      setScrollOffset(pageYOffset);
    };
    window.addEventListener('message', parentScrollEvent);

    return () => window.removeEventListener('message', parentScrollEvent);
  }, []);

  // 親windowからビューポートの高さなどを受け取る
  // オリジン制約により、parent.window.innerHeightなど参照できないため
  const [parentViewportHeight, setParentViewportHeight] = useState(0);
  const [marginToTop, setMarginToTop] = useState(0);
  useEffect(() => {
    const parentResizeEvent = (event: MessageEvent) => {
      const { viewportHeight, marginToTop } = event.data;
      if (!viewportHeight || !marginToTop) return;

      setParentViewportHeight(viewportHeight);
      setMarginToTop(marginToTop);
    };
    window.addEventListener('message', parentResizeEvent);

    return () => window.removeEventListener('message', parentResizeEvent);
  }, []);

  useEffect(() => {
    window.parent.postMessage({ action: 'prepared' }, '*');
  }, []);

  const { addCartProducts } = useSubscriptionAddProducts(setting);

  const failed = (message: string) => {
    setMessageContent({
      title: '内部エラー',
      body: 'BOXプランの更新に失敗しました。',
    });
    setMessageModalActive(true);

    console.log(message);
    setLoading(false);
  };

  const addProductSuccess = (showModal: boolean) => {
    if (showModal) {
      setMessageContent({
        title: 'BOXプランの更新',
        body: '商品をBOXプランに追加しました。',
      });
      setMessageModalActive(true);
    }

    getRegisteredProducts(
      (infos) => {
        setLoading(false);
      },
      (message) => {
        console.log(message);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    const messageEvent = (e: MessageEvent) => {
      if (!e.data.cartItems) return;

      setCartItems(e.data.cartItems);
    };
    window.addEventListener('message', messageEvent);

    return () => window.removeEventListener('message', messageEvent);
  }, [addCartProducts, addProductSuccess]);

  useEffect(() => {
    if (cartItems.length === 0 || !loadCompleted) return;

    addCartProducts(cartItems, () => addProductSuccess(true), failed);
  }, [loadCompleted, cartItems]);

  const { updateDeliveryDate } = useUpdateDeliveryDate(
    setting,
    subscriptionDetail,
    summary,
    () => {
      setChangeDeliveryDateModalActive(false);
      getSubscriptionDetail(
        () => setLoading(false),
        (e) => {
          console.log(e);
          setLoading(false);
        }
      );
    },
    failed
  );

  const removeProductSuccess = async (lineId: string) => {
    // const newRegisteredProducts = registeredProducts.map((product) => {
    //   if (product.lineId === lineId) {
    //     delete product.lineId;

    //     return {
    //       ...product,
    //       quantity: 0,
    //       active: false,
    //     };
    //   }

    //   return product;
    // });

    // const newPausedProducts = pausedProducts.map((product) => {
    //   if (product.lineId === lineId) {
    //     delete product.lineId;

    //     return {
    //       ...product,
    //       quantity: 0,
    //       active: false,
    //     };
    //   }

    //   return product;
    // });

    // const newRecommendProducts = recommendProducts.map((product) => {
    //   if (product.lineId === lineId) {
    //     delete product.lineId;

    //     return {
    //       ...product,
    //       quantity: 0,
    //       active: false,
    //     };
    //   }

    //   return product;
    // });

    // const registeredTotal = newRegisteredProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.price * product.quantity;
    // }, 0);

    // const registeredOriginalTotal = newRegisteredProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.originalPrice * product.quantity;
    // }, 0);

    // const pausedTotal = newPausedProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.price * product.quantity;
    // }, 0);

    // const recommendTotal = newRecommendProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.price * product.quantity;
    // }, 0);

    // setRegisteredProducts(newRegisteredProducts);
    // setPausedProducts(newPausedProducts);
    // setRecommendProducts(newRecommendProducts);

    // console.log('setSummary in 338');
    // // サマリの合計金額を更新する
    // setSummary({
    //   ...summary!,
    //   totalPrice: summary!.deliveryPrice + registeredTotal + pausedTotal + recommendTotal,
    //   totalOriginalPrice: summary!.deliveryPrice + registeredOriginalTotal + pausedTotal + recommendTotal,
    // });

    setLoading(false);
  };

  const updateQuantitySuccess = (lineId: string, quantity: number) => {
    // 数量を更新する
    // const newRegisteredProducts = registeredProducts.map((product) => {
    //   if (lineId !== product.lineId) return product;

    //   return {
    //     ...product,
    //     quantity,
    //   };
    // });

    // const newPausedProducts = pausedProducts.map((product) => {
    //   if (lineId !== product.lineId) return product;

    //   return {
    //     ...product,
    //     quantity,
    //   };
    // });

    // const newRecommendProducts = recommendProducts.map((product) => {
    //   if (lineId !== product.lineId) return product;

    //   return {
    //     ...product,
    //     quantity,
    //   };
    // });

    // const registeredTotal = newRegisteredProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.price * product.quantity;
    // }, 0);

    // const registeredOriginalTotal = newRegisteredProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.originalPrice * product.quantity;
    // }, 0);

    // const pausedTotal = newPausedProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.price * product.quantity;
    // }, 0);

    // const recommendTotal = newRecommendProducts.reduce((sum, product) => {
    //   if (!product.active) return sum;

    //   return sum + product.price * product.quantity;
    // }, 0);

    // setRegisteredProducts(newRegisteredProducts);
    // setPausedProducts(newPausedProducts);
    // setRecommendProducts(newRecommendProducts);

    // console.log('setSummary in 407');
    // // サマリの合計金額を更新する
    // setSummary({
    //   ...summary!,
    //   totalPrice: summary!.deliveryPrice + registeredTotal + pausedTotal + recommendTotal,
    //   totalOriginalPrice: summary!.deliveryPrice + registeredOriginalTotal + pausedTotal + recommendTotal,
    // });

    setLoading(false);
  };

  const { updateQuantity, removeProduct } = useSubscriptionLine(setting, setSubscription);
  const updateQuantityFunc = (lineId: string, quantity: number) => {
    setLoading(true);

    if (quantity > 0) {
      updateQuantity(
        subscriptionContractId,
        lineId,
        quantity,
        () => {
          updateQuantitySuccess(lineId, quantity);
        },
        setSubscriptionContractId,
        setRegisteredProducts,
        setPausedProducts,
        setRecommendProducts,
        failed
      );
    } else {
      removeProduct(
        subscriptionContractId,
        lineId,
        () => {
          removeProductSuccess(lineId);
        },
        setSubscriptionContractId,
        setRegisteredProducts,
        setPausedProducts,
        setRecommendProducts,
        failed
      );
    }
  };

  const cancelSubscriptionFunc = (lineId?: string) => {
    removeProduct(
      subscriptionContractId,
      lineId!,
      () => {
        removeProductSuccess(lineId!);
      },
      setSubscriptionContractId,
      setRegisteredProducts,
      setPausedProducts,
      setRecommendProducts,
      failed
    );
  };

  // 停止中商品から特定タグ付与商品を間引く処理
  useEffect(() => {
    window.parent.postMessage({action: 'updatePausedProducts', pausedProducts:pausedProducts, registeredProducts:registeredProducts}, '*');
  }, [pausedProducts]);

  useEffect(() => {
    const updatePausedProductsEvent = (event: MessageEvent) => {
      if (Boolean(event.data.updatePausedProductsData) === false) return;
      if (event.data.updatePausedProductsData.isDecimated) {
        setPausedProducts(event.data.updatePausedProductsData.products);
      }
    };
    window.addEventListener('message', updatePausedProductsEvent);

    return () => window.removeEventListener('message', updatePausedProductsEvent);
  }, []);

  // ピックアップ商品から購入済み初回割商品を間引く処理
  useEffect(() => {
    window.parent.postMessage({action: 'updateRecommendProducts', recommendProducts}, '*');
  }, [recommendProducts]);

  useEffect(() => {
    const updateRecommendProductsEvent = (event: MessageEvent) => {
      if (Boolean(event.data.updateRecommendProductsData) === false) return;
      if (event.data.updateRecommendProductsData.isDecimated) {
        setRecommendProducts(event.data.updateRecommendProductsData.products);
      }
    };
    window.addEventListener('message', updateRecommendProductsEvent);

    return () => window.removeEventListener('message', updateRecommendProductsEvent);
  }, []);

  return (
    <>
      <div className={classes.mypage_subsc_container} ref={root}>
        <PickupShippingProductList
          products={registeredProducts}
          loading={loading}
          cancelSubscriptionFunc={cancelSubscriptionFunc}
          updateQuantityFunc={updateQuantityFunc}
          setChangeDeliveryDateModalFunc={setChangeDeliveryDateModalActive}
        />

        <PickupProductListPickup
          pickUpProducts={recommendProducts}
          loading={loading}
          setting={setting}
          addProductSuccess={addProductSuccess}
          failed={failed}
          setSubscriptionContractId={setSubscriptionContractId}
          setRegisteredProducts={setRegisteredProducts}
          setPausedProducts={setPausedProducts}
          setRecommendProducts={setRecommendProducts}
          setSubscription={setSubscription}
        />

        <BackToSubscriptionTop />

        <Menu/>
      </div>
      <ChangeDeliveryDateModal
        active={changeDeliveryDateModalActive}
        scrollOffset={scrollOffset}
        parentViewportHeight={parentViewportHeight}
        marginToTop={marginToTop}
        summary={summary}
        updateDeliveryDate={updateDeliveryDate}
        closeFunc={() => setChangeDeliveryDateModalActive(false)}
      />
      <MessageModal
        active={messageModalActive}
        scrollOffset={scrollOffset}
        parentViewportHeight={parentViewportHeight}
        marginToTop={marginToTop}
        closeFunc={() => setMessageModalActive(false)}
        messageContent={messageContent}
      />
    </>
  );
};
